import React from "react";
// import shaw_logo from "./BrandLogo/shaw_logo.webp";
// import anderson_tuftex_logo from "./BrandLogo/anderson_tuftex_logo.webp";
// import karastan_logo from "./BrandLogo/karastan_logo.webp";
// import armstrong_logo from "./BrandLogo/armstrong_logo.webp";
// import dreamweaver_logo from "./BrandLogo/dreamweaver_logo.webp";
// import philadelphia_commercial_logo from "./BrandLogo/philadelphia_commercial_logo.webp";
// import coretec_logo from "./BrandLogo/coretec_logo.webp";
// import daltile_logo from "./BrandLogo/daltile_logo.webp";
// import mohawk_logo from "./BrandLogo/mohawk_logo.webp";
// import bruce_logo from "./BrandLogo/bruce_logo.webp";
// import amrican_olean_logo from "./BrandLogo/amrican_olean_logo.webp";
// import mannington_logo from "./BrandLogo/mannington_logo.webp";
// import fabrica from "./BrandLogo/fabrica.webp";
// import masland from "./BrandLogo/masland.webp";
// import dixie from "./BrandLogo/dixie_home.webp";
// import nourison_logo from "./BrandLogo/nourison_logo.webp";
// import hydraluxe_logo from "./BrandLogo/hydraluxe_logo.webp";
// import karndean_logo from "./BrandLogo/karndean_logo.webp";
// import cali_logo from "./BrandLogo/cali-brand-logo.png";
// import robbins from "./BrandLogo/robbins.webp";
// import mercier from "./BrandLogo/mercier.webp";
// import hallmark from "./BrandLogo/hallmark.webp";
// import bella_cera from "./BrandLogo/bella_cera.webp";
// import godfrey_hirst from "./BrandLogo/godfrey_hirst.webp";
// import emsertile_logo from "./BrandLogo/emsertile_logo.webp";
// import marazzi from "./BrandLogo/marazzi.webp";
// import happy_feet from "./BrandLogo/happy_feet.webp";
// import happy_floors from "./BrandLogo/happy_floors.webp";
// import somerset from "./BrandLogo/somerset.webp";
// import naturally_aged_flooring from "./BrandLogo/naturally_aged_flooring.webp";
// import msi_tile from "./BrandLogo/msi_tile.webp";
// import stanton from "./BrandLogo/stanton.webp";
// import kingsmen from "./BrandLogo/kingsmen_logo.webp";

// import thandmain from "./BrandLogo/5thandmain-logo.webp";
// import aladdin_commercial from "./BrandLogo/Aladdin-Commercial.webp";
// import nourtex from "./BrandLogo/Nourtex-nourison-logo.webp";
// import kane from "./BrandLogo/kane-carpet.webp";
// import antrim from "./BrandLogo/antrim-logo.webp";
// import hagaman from "./BrandLogo/Hagaman-nourison-logo.webp";
// import hartco from "./BrandLogo/hartco-hardwood.webp";
// import pergo from "./BrandLogo/pergo.webp";
// import republic from "./BrandLogo/republic.webp";
// import shaw_builder from "./BrandLogo/shaw-builder-logo.webp";
// import provenza from "./BrandLogo/provenza.webp";

// import ColorDestinationLogo from "./BrandLogo/Color_Destination_Logo_1.webp";
// import CarpetsPlusPetPerfDestinationLogo from "./BrandLogo/CarpetsPlus_Pet_Perf_Destination_Logo.webp";
// import ColorDestinationWhite1Logo from "./BrandLogo/Color_Destination_White_1_Logo.webp";
// import COLORTILEHDLuxVinylFlooringBlack2 from "./BrandLogo/COLORTILE_HD_Lux_Vinyl_Flooring_Black_2.webp";
// import COLORTILENatureMarkHWlogo800px from "./BrandLogo/COLORTILE_NatureMark_HW_logo_800px.webp";
// import COLORTILEPrimeLuxuryVinylFlooringwithCTtech from "./BrandLogo/COLORTILE_Prime_Luxury_Vinyl_Flooring_with_CT_tech.webp";
// import COLORTILEProElitePerformancePlankftCOREtecTechblack2 from "./BrandLogo/COLORTILE_Pro_Elite_Performance_Plank_ft_COREtecTech_black2.webp";
// import COLORTILEProLuxVinylPlankLogo500px2 from "./BrandLogo/COLORTILE_Pro_Lux_Vinyl_Plank_Logo_500px_2.webp";
// import COLORTILEProWaterproofPerformanceFlooringLVP from "./BrandLogo/COLORTILE_Pro_Waterproof_Performance_Flooring_LVP.webp";
// import COLORTILESelectLVFlooringLogo2 from "./BrandLogo/COLORTILE_Select_LV_Flooring_Logo_2.webp";
// import COLORTILESelectPremierLVFlooringBlackwithCTtech from "./BrandLogo/COLORTILE_Select_Premier_LV_Flooring_Black_with_CT_tech.webp";
// import COLORTILEUltraHDSignatureFlooringLogo2 from "./BrandLogo/COLORTILE_Ultra_HD_Signature_Flooring_Logo_2.webp";
// import ElitePerformanceHomeLogoBLACK from "./BrandLogo/Elite_Performance_Home_Logo_BLACK.webp";
// import HardwoodDestinationLogo from "./BrandLogo/Hardwood_Destination_Logo.webp";
// import HomeGallery10fotorbgremover20230818113248 from "./BrandLogo/Home_Gallery_1.0_fotor_bg_remover_20230818113248.webp";
// import HomeGallery20fotorbgremover20230818113442 from "./BrandLogo/Home_Gallery_2.0_fotor_bg_remover_20230818113442.webp";
// import Korlok1536x439fotorbgremover20230818114347 from "./BrandLogo/Korlok_1536x439_fotor_bg_remover_20230818114347.webp";
// import LuxuryFlooringDestination1logo from "./BrandLogo/Luxury_Flooring_Destination_1_logo.webp";
// import milancollectionlogo from "./BrandLogo/milan_collection_product_page_header.webp";
// import PureColorDestinationLogo12048x857 from "./BrandLogo/PureColor_Destination_Logo_1_2048x857.webp";

function ProductBrandLogos({ product }) {
  return (
    <div>
      {product.brand_facet.toLowerCase() === "shaw floors" ||
      product.brand_facet.toLowerCase() === "shaw" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/shaw-floors-logo.webp"
          alt="Shaw Logo"
        />
      ) : product.brand_facet.toLowerCase() === "anderson tuftex" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/anderson-tuftex-logo.webp"
          alt="Anderson Tuftex"
        />
      ) : product.brand_facet.toLowerCase() === "karastan" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/karastan-logo.webp"
          alt="Karastan"
        />
      ) : product.brand_facet.toLowerCase() === "armstrong" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/armstrong-logo.webp"
          alt="Armstrong"
        />
      ) : product.brand_facet.toLowerCase() === "dreamweaver" ||
        product.brand_facet.toLowerCase() === "dream weaver" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/dreamweaver_logo.webp"
          alt="Dream Weaver"
        />
      ) : product.brand_facet.toLowerCase() === "philadelphia commercial" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/philadelphia-commercial-logo.webp"
          alt="Philadelphia Commercial"
        />
      ) : product.brand_facet.toLowerCase() === "coretec" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/coretec-logo.webp"
          alt="COREtec"
        />
      ) : product.brand_facet.toLowerCase() === "daltile" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/daltile.webp"
          alt="Daltile"
        />
      ) : product.brand_facet.toLowerCase() === "mohawk" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/mohawk-logo.webp"
          alt="Mohawk"
        />
      ) : product.brand_facet.toLowerCase() === "bruce" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/bruce.webp"
          alt="Bruce"
        />
      ) : product.brand_facet.toLowerCase() === "american olean" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/american-olean.webp"
          alt="American Olean"
        />
      ) : product.brand_facet.toLowerCase() === "mannington" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/mannington.webp"
          alt="Mannington"
        />
      ) : product.brand_facet.toLowerCase() === "fabrica" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/fabrica-logo.webp"
          alt="Fabrica"
        />
      ) : product.brand_facet.toLowerCase() === "masland" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/masland.webp"
          alt="Masland"
        />
      ) : product.brand_facet.toLowerCase() === "dixie home" ||
        product.brand_facet.toLowerCase() === "dixiehome" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/dixie-home.webp"
          alt="Dixie Home"
        />
      ) : product.brand_facet.toLowerCase() === "nourison" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/nourison_logo.webp"
          alt="Nourison"
        />
      ) : product.brand_facet.toLowerCase() === "hydraluxe" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/hydraluxe_logo.webp"
          alt="Hydraluxe"
        />
      ) : product.brand_facet.toLowerCase() === "karndean" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/karndean.webp"
          alt="Karndean"
        />
      ) : product.brand_facet.toLowerCase() === "cali" ? (
        <img
          width="100"
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/cali-brand-logo.webp"
          alt="Cali"
        />
      ) : product.brand_facet.toLowerCase() === "canopy" ||
        product.brand_facet.toLowerCase() === "canopy floors" ? (
        <img
          width="100"
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/canopy.webp"
          alt="Canopy"
        />
      ) : product.brand_facet.toLowerCase() === "robbins" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Robbins.webp"
          alt="Robbins"
        />
      ) : product.brand_facet.toLowerCase() === "mercier" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/mercier-hardwood.webp"
          alt="Mercier"
        />
      ) : product.brand_facet.toLowerCase() === "hallmark" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/hallmark-floors.webp"
          alt="Hallmark"
        />
      ) : product.brand_facet.toLowerCase() === "bella cera" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/bellacera.webp"
          alt="Bella Cera"
        />
      ) : product.brand_facet.toLowerCase() === "godfrey hirst" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/godfrey-hirst.webp"
          alt="Godfrey Hirst"
        />
      ) : product.brand_facet.toLowerCase() === "stanton" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/stanton.webp"
          alt="Stanton"
        />
      ) : product.brand_facet.toLowerCase() === "emser" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/emser-tile.webp"
          alt="Emser"
        />
      ) : product.brand_facet.toLowerCase() === "marazzi" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/marazzi.webp"
          alt="Marazzi"
        />
      ) : product.brand_facet.toLowerCase() === "happy feet" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/happy_feet.webp"
          alt="Happy Feet"
        />
      ) : product.brand_facet.toLowerCase() === "happy floors" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Happy-floors-logo.webp"
          alt="Happy Floors"
        />
      ) : product.brand_facet.toLowerCase() === "somerset" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/somerset-hardwood.webp"
          alt="Somerset"
        />
      ) : product.brand_facet.toLowerCase() === "naturally aged flooring" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/naturally-aged-flooring.webp"
          alt="Naturally Aged Flooring"
        />
      ) : product.brand_facet.toLowerCase() === "msi tile" ||
        product.brand_facet.toLowerCase() === "msi" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/MSI.webp"
          alt="MSI Tile"
        />
      ) : product.brand_facet.toLowerCase() === "kingsmen" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/kingsmen_logo.webp"
          alt="Kingsmen"
        />
      ) : product.brand_facet.toLowerCase() === "5th and main" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/5thandmain-logo.webp"
          alt="5th And Main"
        />
      ) : product.brand_facet.toLowerCase() === "aladdin commercial" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Aladdin-Commercial.webp"
          alt="Aladdin Commercial"
        />
      ) : product.brand_facet.toLowerCase() === "nourtex" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Nourtex-nourison-logo.webp"
          alt="Nourtex"
        />
      ) : product.brand_facet.toLowerCase() === "kane" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/kane-carpet.webp"
          alt="Kane"
        />
      ) : product.brand_facet.toLowerCase() === "antrim" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/antrim-logo.webp"
          alt="Antrim"
        />
      ) : product.brand_facet.toLowerCase() === "hagaman" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Hagaman-nourison-logo.webp"
          alt="Hagaman"
        />
      ) : product.brand_facet.toLowerCase() === "hartco" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/hartco-hardwood.webp"
          alt="Hartco"
        />
      ) : product.brand_facet.toLowerCase() === "pergo" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/pergo.webp"
          alt="Pergo"
        />
      ) : product.brand_facet.toLowerCase() === "republic" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/republic.webp"
          alt="Republic"
        />
      ) : product.brand_facet.toLowerCase() === "shaw builder flooring" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/shaw-builder-logo.webp"
          alt="Shaw Builder Flooring"
        />
      ) : product.brand_facet.toLowerCase() === "provenza" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/provenza.webp"
          alt="Provenza"
        />
      ) : product.brand_facet.toLowerCase() === "tarkett" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/tarkett-flooring.webp"
          alt="Tarkett"
        />
      ) : product.brand_facet.toLowerCase() === "trucor" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Trucor-logo.webp"
          alt="Trucor"
        />
      ) : product.brand_facet.toLowerCase() === "palmetto road" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/palmetto-road-logo.webp"
          alt="Palmetto Road"
        />
      ) : product.brand_facet.toLowerCase() === "couristan" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/couristan.webp"
          alt="Couristan"
        />
      ) : product.brand_facet.toLowerCase() === "paramount" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Paramount.webp"
          alt="Paramount"
        />
      ) : product.brand_facet.toLowerCase() === "jordans signature series" ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/signature_series.webp"
          alt="Jordans Signature Series"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("pet performance destination", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/CarpetsPlus_Pet_Perf_Destination_Logo.webp"
          alt="Pet Performance Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination carpet collection", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Color_Destination_Logo.webp"
          alt="Color Destination Carpet Collection"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("pure color destination", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/PureColor_Destination_Logo.webp"
          alt="Pure Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Color_Destination_White_Logo.webp"
          alt="Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("elite performance home", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Elite_Performance_Home_Logo.webp"
          alt="Elite Performance Home"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("milan collection", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/milan_collection_logo.webp"
          alt="Milan Collection"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile prime luxury vinyl flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Prime_Luxury_Vinyl_Flooring_with_CT_tech.webp"
          alt="Colortile Prime Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile hd luxury vinyl flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_HD_Lux_Vinyl_Flooring.webp"
          alt="Colortile HD Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl tile", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Tile"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl plank", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Plank"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro waterproof performance flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Pro_Waterproof_Performance_Flooring_LVP.webp"
          alt="Colortile Pro Waterproof Performance Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile select luxury vinyl flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Select_LV_Flooring_Logo.webp"
          alt="Colortile Select Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile select premier luxury vinyl flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Select_Premier_LV_Flooring_Black_with_CT_tech.webp"
          alt="Colortile Select Premier Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("hardwood destination", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Hardwood_Destination_Logo.webp"
          alt="Hardwood Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile ultra hd signature flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Ultra_HD_Signature_Flooring_Logo.webp"
          alt="Colortile Ultra HD Signature Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("home gallery tile 1.0", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Home_Gallery_1.0.webp"
          alt="Home Gallery Tile 1.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("home gallery tile 2.0", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Home_Gallery_2.0.webp"
          alt="Home Gallery Tile 2.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile naturemark waterproof hardwood", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_NatureMark_HW_logo.webp"
          alt="Colortile Naturemark Waterproof Hardwood"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("luxury flooring destination 2.0", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Luxury_Flooring_Destination_1_logo.webp"
          alt="Luxury Flooring Destination 2.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Color_Destination_White_1_Logo.webp"
          alt="Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("elite performance waterproof flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/COLORTILE_Pro_Elite_Performance_Plank_ft_COREtecTech.webp"
          alt="Elite Performance Waterproof Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile design statement flooring", 0) ? (
        <img
          src="/wp-content/plugins/mm-product-listing/build/BrandLogo/Korlok.webp"
          alt="Colortile Design Statement Flooring"
        />
      ) : (
        <p>{product.brand_facet}</p>
      )}
    </div>
  );
}

export default ProductBrandLogos;
